import Logger from '@/lib/logger';
import { NEXT_PUBLIC_HOTJAR_LOGGING_ENABLED } from '@/lib/env';

const logger = new Logger('Hotjar', 'DEBUG');

if (NEXT_PUBLIC_HOTJAR_LOGGING_ENABLED) {
  logger.enable();
}

export default logger;
